import Seo from "@/lib/Seo";
import { FadeUp } from "@/lib/motion";
import { SITE } from "@/data/content";
import Breadcrumbs from "@/components/Breadcrumbs";

export default function Privacy() {
  return (
    <div className="pt-[72px]">
      <Seo
        title="Privacy Notice — Marble & Veil"
        description="How Marble & Veil handles the information you share through inquiry forms and the owner admin."
        path="/privacy"
      />
      <section className="mx-auto max-w-3xl px-5 py-16 sm:px-8 lg:py-24">
        <Breadcrumbs trail={[["Home", "/"], ["Privacy"]]} />
        <FadeUp>
          <h1 className="mt-6 font-display text-5xl leading-[1.05] text-ink sm:text-6xl">Privacy Notice</h1>
          <p className="mt-5 border-l-2 border-olive/50 pl-5 text-sm leading-relaxed text-smoke" data-testid="privacy-draft-note">
            Draft for owner review before production launch. This notice describes how the staging
            build actually handles information; the final version is reviewed and approved by the
            owner before the site goes live.
          </p>
        </FadeUp>

        <FadeUp delay={0.05}>
          <div className="mt-12 space-y-10 text-[15px] leading-relaxed text-smoke">
            <section>
              <h2 className="font-display text-2xl text-ink">What we collect</h2>
              <p className="mt-3">
                When you submit an inquiry, we collect what you choose to share: your name, email, and
                optional phone number; your event date (or "date not set"); venue or city; the details,
                items, palettes, and notes you include; and whether you permit phone contact. If you
                opt in separately, we may also send you occasional email updates — that permission is
                optional, unchecked by default, and never required to use the site.
              </p>
            </section>
            <section>
              <h2 className="font-display text-2xl text-ink">What we do not collect</h2>
              <p className="mt-3">
                We do not ask for full addresses, guest lists, or payment information at the inquiry
                stage, and we do not use advertising trackers on this site. Your quote-list selections
                and palette preferences are saved only in your own browser until you submit them.
              </p>
            </section>
            <section>
              <h2 className="font-display text-2xl text-ink">How it is stored</h2>
              <p className="mt-3">
                Inquiries are stored in the site's private database with a unique inquiry ID and
                timestamp, accessible only to the owners through an authenticated admin account. Quote
                lists kept on your device stay there; we never receive them until you submit.
              </p>
            </section>
            <section>
              <h2 className="font-display text-2xl text-ink">How it is used</h2>
              <p className="mt-3">
                We review your inquiry and reply using your preferred contact method. We do not sell,
                rent, or trade your information, and we do not share it beyond the services needed to
                operate the site. Submitting an inquiry does not reserve a date or commit you to a
                purchase.
              </p>
            </section>
            <section>
              <h2 className="font-display text-2xl text-ink">Your choices</h2>
              <p className="mt-3">
                You may ask us at any time what we hold about you, request a correction, or ask us to
                delete your inquiry. Email us at{" "}
                <a href={`mailto:${SITE.email}`} className="border-b border-olive text-olive">{SITE.email}</a>.
              </p>
            </section>
            <section>
              <h2 className="font-display text-2xl text-ink">Changes</h2>
              <p className="mt-3">
                If this notice changes materially before launch, the owner-approved version will
                replace this draft and the change will be noted on this page.
              </p>
            </section>
          </div>
        </FadeUp>
      </section>
    </div>
  );
}
